import { RequestBuilder } from "../requestBuilder";
import {
  BillingAlertThresholdsResponseSchema,
  BillingContactsResponseSchema,
  BillingMembersResponseSchema,
  NotificationIdParamsSchema,
  NotificationsListParamsSchema,
  NotificationsListResponseSchema,
  RunningPromptsResponseSchema,
  UnreadCountResponseSchema,
  UpdateBillingAlertThresholdsInputSchema,
  UpdateBillingContactsInputSchema,
} from "./notificationsClient.types";

// GET /notifications - The current user's notifications, newest first, paged by
// opaque cursor (user-scoped).
export const ListNotificationsRequestConfig = new RequestBuilder({
  paramsSchema: NotificationsListParamsSchema,
  path: () => "/notifications",
  responseSchema: NotificationsListResponseSchema,
})
  .withContentType(undefined)
  .withQueryParams((params) => {
    if (!params) return undefined;
    const out: Record<string, string> = {};
    if (params.cursor !== undefined) out.cursor = params.cursor;
    if (params.limit !== undefined) out.limit = String(params.limit);
    return out;
  });

// GET /notifications/unread-count - Unread badge count (user-scoped).
export const UnreadCountRequestConfig = new RequestBuilder({
  path: () => "/notifications/unread-count",
  responseSchema: UnreadCountResponseSchema,
}).withContentType(undefined);

// PUT /notifications/{notificationId}/read - Mark one notification read (204).
export const MarkNotificationReadRequestConfig = new RequestBuilder({
  paramsSchema: NotificationIdParamsSchema,
  path: ({ notificationId }) => `/notifications/${notificationId}/read`,
})
  .withMethod("PUT")
  .withContentType(undefined);

// PUT /notifications/read-all - Mark every notification read (204).
export const MarkAllNotificationsReadRequestConfig = new RequestBuilder({
  path: () => "/notifications/read-all",
})
  .withMethod("PUT")
  .withContentType(undefined);

// DELETE /notifications/{notificationId} - Remove one notification (204).
export const DeleteNotificationRequestConfig = new RequestBuilder({
  paramsSchema: NotificationIdParamsSchema,
  path: ({ notificationId }) => `/notifications/${notificationId}`,
})
  .withMethod("DELETE")
  .withContentType(undefined);

// GET /orgs/billing/alert-thresholds - Org credit alert percentages (owner-only).
export const GetBillingAlertThresholdsRequestConfig = new RequestBuilder({
  path: () => "/orgs/billing/alert-thresholds",
  responseSchema: BillingAlertThresholdsResponseSchema,
})
  .withContentType(undefined)
  .withIncludeOrganizationId();

// PUT /orgs/billing/alert-thresholds - Full replace of the threshold set.
export const UpdateBillingAlertThresholdsRequestConfig = new RequestBuilder({
  path: () => "/orgs/billing/alert-thresholds",
  responseSchema: BillingAlertThresholdsResponseSchema,
  bodySchema: UpdateBillingAlertThresholdsInputSchema,
})
  .withMethod("PUT")
  .withIncludeOrganizationId();

// GET /orgs/billing/contacts - Users that receive org billing notifications.
export const GetBillingContactsRequestConfig = new RequestBuilder({
  path: () => "/orgs/billing/contacts",
  responseSchema: BillingContactsResponseSchema,
})
  .withContentType(undefined)
  .withIncludeOrganizationId();

// PUT /orgs/billing/contacts - Full replace of the contact set.
export const UpdateBillingContactsRequestConfig = new RequestBuilder({
  path: () => "/orgs/billing/contacts",
  responseSchema: BillingContactsResponseSchema,
  bodySchema: UpdateBillingContactsInputSchema,
})
  .withMethod("PUT")
  .withIncludeOrganizationId();

// GET /orgs/billing/members - Org members for the contact picker.
export const GetBillingMembersRequestConfig = new RequestBuilder({
  path: () => "/orgs/billing/members",
  responseSchema: BillingMembersResponseSchema,
})
  .withContentType(undefined)
  .withIncludeOrganizationId();

// GET /notifications/running - In-flight prompts snapshot (user-scoped).
export const RunningPromptsRequestConfig = new RequestBuilder({
  path: () => "/notifications/running",
  responseSchema: RunningPromptsResponseSchema,
}).withContentType(undefined);
